import React from "react";
import { ID } from "models";

type ContractsCellProps = {
  contracts?: { id: ID }[];
  count?: number;
};

export const ContractsCell = ({ contracts = [], count }: ContractsCellProps) => {
  if (count) {
    const ids = contracts.map(c => c.id).join(",");

    return (
      <td>
        <a href={`#/contract/?id=${ids}`}>{count}</a>
      </td>
    );
  }

  return <td>{count ?? 0}</td>;
};